// sentry logging

import Vue from 'vue';
import _ from 'lodash';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import config from './config';

const BLACKLISTED_DOMAINS = ['segment.io', 'mixpanel', 'datadog'];

/* eslint-disable */
const SentryModule = {
  init() {
    Sentry.init({
      dsn: config.get().sentryDsn,
      integrations: [
        new Integrations.Vue({Vue, attachProps: true, logErrors: config.get().logErrors === 'true'}),
        new Integrations.CaptureConsole({ levels: ['error']})
      ],
      beforeBreadcrumb(breadcrumb, hint) {
        if (breadcrumb.category === 'xhr' &&
          (_isDomainBlacklisted(breadcrumb.data.url) || _isInvalidToken(breadcrumb))) {
          return null;
        }
        return breadcrumb;
      },
    });
  },
  addBreadcrumb(category, message, level) {
    Sentry.addBreadcrumb({
      category,
      message,
      level,
    });
  }
};

function _isInvalidToken(breadcrumb) {
  return breadcrumb.data.status_code === 403;
}

function _isDomainBlacklisted(url) {
  return _.some(BLACKLISTED_DOMAINS, domain => {
      return _.includes(url, domain);
    });
}

export default SentryModule;



// WEBPACK FOOTER //
// ./src/Sentry.js